import api from "../../../../api/api";
import API_URL from "../../../../api/url";
import axios from 'axios';
 
 const VideoRequest =  {

    createVideo: (values) => api.post(`${API_URL.BASEURL}${API_URL.createVideo}`, values),
    updatevideo: (values) => api.post(`${API_URL.BASEURL}${API_URL.updatevideo}`, values),
    videoList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getVideo}`, {
        params: {
          
            search: values?.search
          }
    }),
    deletevideo: (id) => api.post(`${API_URL.BASEURL}${API_URL.deletevideo}`, id),
    videoDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.videoDetail}?id=${id}`),

    uploadImage: (formData) => {
        const token = localStorage.getItem("accesstoken");
    
    
        return api.post(
          `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
          formData,
          {
            headers: {
              token: token ? `${token}` : "",
            },
          }
        );
      }
 };
 
 export default VideoRequest